import * as React from 'react'
import '../../styles/form-animations.css'
import PhoneLink from '../PhoneLink'

const SubmitButton = ({ onClick, submit, progress, error }) => {
  const clickHandler = React.useCallback(
    e => {
      if (onClick) onClick(e)
    },
    [onClick]
  )
  const [loadingDelay, setLoadingDelay] = React.useState(false)

  React.useEffect(() => {
    if (submit) {
      const timeout = setTimeout(() => {
        setLoadingDelay(true)
      }, 1000) // 1-second delay

      return () => clearTimeout(timeout) // Cleanup on unmount
    }
  }, [submit])

  return (
    <div
      className={
        (submit
          ? 'h-[100%] bg-white border-gray-300 '
          : 'h-20 bg-transparent  border-transparent ') +
        'w-full absolute bottom-0 border duration-500 ease-in-out z-50 flex justify-center items-center'
      }
    >
      <button
        onClick={clickHandler}
        className={
          (submit
            ? 'duration-700 ease-[cubic-bezier(.89,-0.83,.46,1.27)] w-[3.75rem] '
            : '  w-48 ') +
          (error ? ' -translate-y-[100%] ' : ' -translate-y-[50%] ') +
          'rounded-full h-[3.75rem] border-[5px] border-gray-500  text-gray-700 hover:text-accent font-bold  hover:tracking-wider hover:border-accentMd absolute duration-200 top-[50%]'
        }
      >
        {!submit && <p>SUBMIT</p>}

        {submit && (
          <div className=" -rotate-90 w-[3.75rem] h-[3.75rem] -translate-x-[5px] -translate-y-[5px]">
            <svg
              className="fill-current text-transparent"
              viewBox="-5 -5 110 110"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                style={{
                  strokeDashoffset: loadingDelay ? `${(1 - progress) * 360}px` : '360px',
                }}
                className={'formLoader-stroke  ' + (error ? ' stroke-red-500' : 'stroke-green-400')}
                cx="50"
                cy="50"
                r="50"
              />
            </svg>
            <div
              className={
                (progress === 1 && loadingDelay ? 'text-[2.25rem] ' : 'text-[0rem] ') +
                (error ? ' text-red-500' : 'text-green-400') +
                ' rotate-90 absolute top-0 left-0  w-full h-full flex justify-center items-center  duration-500 ease-[cubic-bezier(.42,-0.57,.32,1.85)]'
              }
            >
              {error ? <p>&#10005;</p> : <p> &#x2713;</p>}
            </div>
          </div>
        )}
      </button>
      {error && (
        <div className="fade-in text-red-500 w-10/12 text-center translate-y-16 ">
          We are unable to send your message at this time. Please contact us
          <br />
          <div className="space-x-4">
            Call Us: <PhoneLink />{' '}
            <button className="bg-red-600 text-white px-3 py-1">Live Chat</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default SubmitButton
